import axios from "axios";

const API_URL = (process.env.VUE_APP_API_BASE_URL || "http://localhost:3000") + "/api";

export default {
  async register(userData) {
    const response = await axios.post(`${API_URL}/auth/signup`, userData);
    if (response.data.token) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  },

  async login(email, password) {
    const response = await axios.post(`${API_URL}/auth/login`, { email, password });
    if (response.data.token) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  },

  logout() {
    localStorage.removeItem("user");
  },

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  },

  async getProfile() {
    const user = this.getCurrentUser();
    if (!user) return null;

    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const response = await axios.get(`${API_URL}/auth/profile`, config);
    return response.data;
  },

  async updateProfile(profileData) {
    const user = this.getCurrentUser();
    if (!user) return null;

    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const response = await axios.put(`${API_URL}/auth/profile`, profileData, config);

    // Update the stored user data if email or name changed
    if (response.data) {
      const updatedUser = {
        ...user,
        name: response.data.name,
        email: response.data.email,
      };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    }

    return response.data;
  },
};
